import { useState } from 'react';
import { quantityOptions } from '../catalog';
import { useCart } from '../context/CartContext';

export default function ProductCard({ product, compact = false }) {
  const { addToCart } = useCart();
  const [weight, setWeight] = useState(quantityOptions[0]);
  const [count, setCount] = useState(1);

  const dec = () => setCount((c) => Math.max(1, c - 1));
  const inc = () => setCount((c) => c + 1);

  const handleAdd = () => {
    addToCart(product, weight, count);
  };

  return (
    <article className={`product-card enhanced-product-card${compact ? ' product-card--compact' : ''}`}>
      <div className="product-image-wrap">
        <img src={product.image} alt={product.name} className="product-image" />
      </div>

      <div className="product-content">
        <h3 className="product-title">{product.name}</h3>

        <div className="select-wrap">
          <select
            className="product-size-select weight-select"
            value={weight}
            onChange={(e) => setWeight(e.target.value)}
            aria-label={`Weight for ${product.name}`}
          >
            {quantityOptions.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
        </div>

        <div className="quantity-control modern-quantity-control">
          <button type="button" className="qty-btn qty-btn-minus" onClick={dec} disabled={count <= 1} aria-label="Decrease quantity">
            −
          </button>
          <span className="qty-value">{count}</span>
          <button type="button" className="qty-btn qty-btn-plus" onClick={inc} aria-label="Increase quantity">
            +
          </button>
        </div>

        <button type="button" className="order-btn" onClick={handleAdd}>
          Add to Cart
        </button>
      </div>
    </article>
  );
}
